import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import styles from './res.module.scss';
import AnalysisHostory from './analysisHostory';
import { Title, Button } from '../landingComponents/typography';
import { LandingHorizontalBlock } from '../landingComponents/containers/common';
import LandingButton from '../landingComponents/button';
import BreadcrumbSchema from '../breadcrumbs/schema';

export default function OrderRequest() {
  const history = useNavigate();
  const [inputCode, setCode] = useState('');

  const requestAnalysis = () => {
    history(`/order/${inputCode}`);
  };

  return (
    <LandingHorizontalBlock className={styles.landingWrapper}>
      <BreadcrumbSchema
        currentPage="orderRequest"
        description="Получение ранее внесенной информации по уникальному коду. Повторное использование данных."
      />
      <Paper className={styles.container} sx={{ borderRadius: '20px' }}>
        <Title accent>Просмотр результата запроса</Title>
        {/* <Typography variant="h5" gutterBottom>
      </Typography> */}
        <AnalysisHostory onHistoryElementClick={setCode} />
        <div className={styles.result}>
          <TextField
            label="Код запроса"
            value={inputCode}
            onChange={(e) => {
              setCode(e.target.value);
            }}
            helperText=""
          ></TextField>
        </div>
        <div className={styles.management}>
          <LandingButton
            variant="contained"
            onClick={requestAnalysis}
            disabled={!inputCode}
          >
            <Button>Запросить анализ</Button>
          </LandingButton>
        </div>
      </Paper>
    </LandingHorizontalBlock>
  );
}
